import { ReferenceSelectorController } from './reference-selector.controller';
import { ReferenceSelectorProps } from './reference-selector.model';

const ReferenceSelector = (props: ReferenceSelectorProps): JSX.Element => {
  return <ReferenceSelectorController {...props} />;
};
export default ReferenceSelector;
